import { PageWithTitle } from 'utils/PageWithTitle'
import OopsCard from 'components/NotFoundCard/OopsCard'

export default function Oops() {
  return (
    <PageWithTitle title="Oops">
      <OopsCard />
    </PageWithTitle>
  )
}
